module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/duquesne-university-1de638b9d74bf6a2c993a3f33e14b3fd.jpg";